enum PortfolioEndpoints {
  DeletePortfolio = "/api/portfolio/deletePortfolio",
  GetPortfolioTable = "/api/portfolio/getPortfolioTable",
}

export default PortfolioEndpoints;
